module.exports = __webpack_public_path__ + "img/20.4e2a494b.svg";